(function () {
  function getMotionSettings() {
    const node = document.getElementById('mw-motion-settings');
    if (!node) {
      return { enabled: true, respectReducedMotion: true, heroVideoAutoplay: true };
    }

    try {
      return JSON.parse(node.textContent);
    } catch {
      return { enabled: true, respectReducedMotion: true, heroVideoAutoplay: true };
    }
  }

  function motionAllowsVideo(settings) {
    if (!settings.enabled || !settings.heroVideoAutoplay) return false;
    if (settings.respectReducedMotion && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return false;
    }
    return true;
  }

  const heroVideo = document.querySelector('.mw-hero__video');
  const heroPoster = document.querySelector('.mw-hero__poster');

  function showHeroPosterFallback() {
    heroPoster?.classList.remove('is-hidden');
  }

  function hideHeroPoster() {
    heroPoster?.classList.add('is-hidden');
  }

  if (heroVideo && motionAllowsVideo(getMotionSettings())) {
    heroVideo.addEventListener('playing', hideHeroPoster, { once: true });
    heroVideo.addEventListener('canplay', hideHeroPoster, { once: true });
    heroVideo.addEventListener('error', showHeroPosterFallback);
    heroVideo.play().catch(showHeroPosterFallback);
  }

  const nav = document.querySelector('.mw-side-nav');
  const toggle = document.querySelector('.mw-side-nav__toggle');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.addEventListener('click', (e) => {
      if (!nav.classList.contains('is-open')) return;
      if (nav.contains(e.target) || toggle.contains(e.target)) return;
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  const app = document.querySelector('.mw-app');
  const allFooterSections = [...document.querySelectorAll('.shopify-section.section-mw-footer')];
  let footerSection = document.querySelector('.mw-app > .shopify-section.section-mw-footer') || allFooterSections[0];

  if (app && footerSection?.classList.contains('section-mw-footer') && footerSection.parentElement !== app) {
    app.appendChild(footerSection);
  }

  allFooterSections.forEach((section) => {
    if (section !== footerSection) {
      section.remove();
    }
  });

  document.querySelectorAll('#MainContent .shopify-section.section-mw-footer').forEach((duplicate) => {
    duplicate.remove();
  });

  footerSection = document.querySelector('.mw-app > .shopify-section.section-mw-footer') || footerSection;

  const cartFab = document.querySelector('.mw-cart-fab');
  const mobileChromeMq = window.matchMedia('(max-width: 1024px)');

  function elementOverlapsFooter(element, footerRect, buffer) {
    if (!element) return false;

    const rect = element.getBoundingClientRect();

    return (
      rect.bottom > footerRect.top + buffer &&
      rect.top < footerRect.bottom - buffer
    );
  }

  function updateFixedChromeVisibility() {
    if (!footerSection) return;

    const footerRect = footerSection.getBoundingClientRect();
    const buffer = 12;

    if (cartFab) {
      const hideCartOverFooter = !mobileChromeMq.matches;
      cartFab.classList.toggle(
        'mw-cart-fab--footer-hidden',
        hideCartOverFooter && elementOverlapsFooter(cartFab, footerRect, buffer)
      );
    }

    if (toggle) {
      const hideToggleOverFooter = !mobileChromeMq.matches;
      const toggleOverlaps = elementOverlapsFooter(toggle, footerRect, buffer);
      toggle.classList.toggle(
        'mw-side-nav__toggle--footer-hidden',
        hideToggleOverFooter && toggleOverlaps
      );

      if (toggleOverlaps && nav?.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }

  if (footerSection && (cartFab || toggle)) {
    let fixedChromeTicking = false;

    function requestFixedChromeUpdate() {
      if (fixedChromeTicking) return;
      fixedChromeTicking = true;
      requestAnimationFrame(() => {
        updateFixedChromeVisibility();
        fixedChromeTicking = false;
      });
    }

    requestFixedChromeUpdate();
    window.addEventListener('scroll', requestFixedChromeUpdate, { passive: true });
    window.addEventListener('resize', requestFixedChromeUpdate, { passive: true });
  }

  const aboutParallaxMq = window.matchMedia('(max-width: 768px)');
  const reducedMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  const aboutPageAllowsParallax =
    document.body.classList.contains('template-page-about') ||
    document.body.classList.contains('template-page-philosophy');
  const aboutHeading = document.querySelector('.mw-about__heading');
  const aboutPortrait = document.querySelector('.mw-about__portrait');

  if (aboutPageAllowsParallax && aboutHeading && aboutPortrait) {
    let aboutParallaxTicking = false;

    function updateAboutHeadingParallax() {
      const shouldParallax = aboutParallaxMq.matches && !reducedMotionMq.matches;

      if (!shouldParallax) {
        aboutHeading.style.removeProperty('--mw-about-heading-parallax-y');
        aboutHeading.style.removeProperty('--mw-about-heading-parallax-blur');
        aboutPortrait.style.removeProperty('--mw-about-portrait-overlay-opacity');
        return;
      }

      const portraitRect = aboutPortrait.getBoundingClientRect();
      const scrollRange = Math.max(1, portraitRect.height);
      const progress = Math.min(1, Math.max(0, -portraitRect.top / scrollRange));
      const parallaxY = Math.round(progress * -480);
      const parallaxBlur = (progress * 4).toFixed(2);
      const portraitOverlayOpacity = (0.2 + progress * 0.55).toFixed(2);

      aboutHeading.style.setProperty('--mw-about-heading-parallax-y', `${parallaxY}px`);
      aboutHeading.style.setProperty('--mw-about-heading-parallax-blur', `${parallaxBlur}px`);
      aboutPortrait.style.setProperty('--mw-about-portrait-overlay-opacity', portraitOverlayOpacity);
    }

    function requestAboutHeadingParallaxUpdate() {
      if (aboutParallaxTicking) return;
      aboutParallaxTicking = true;

      requestAnimationFrame(() => {
        updateAboutHeadingParallax();
        aboutParallaxTicking = false;
      });
    }

    requestAboutHeadingParallaxUpdate();
    window.addEventListener('scroll', requestAboutHeadingParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestAboutHeadingParallaxUpdate, { passive: true });
    aboutParallaxMq.addEventListener('change', requestAboutHeadingParallaxUpdate);
    reducedMotionMq.addEventListener('change', requestAboutHeadingParallaxUpdate);
  }

  const workshops = document.querySelector('.mw-workshops');
  const viewport = document.querySelector('[data-mw-workshop-track]');
  const cardsTrack = document.querySelector('[data-mw-workshop-cards]');
  const scrollHint = document.querySelector('[data-mw-workshop-scroll]');
  const prevBtn = document.querySelector('[data-mw-workshop-prev]');
  const nextBtn = document.querySelector('[data-mw-workshop-next]');
  const pagination = document.querySelector('[data-mw-workshop-pagination]');
  const paginationDots = pagination?.querySelectorAll('[data-mw-workshop-pagination-dot]');
  const mobileCardsMq = window.matchMedia('(max-width: 749px)');

  if (!viewport || !workshops) {
    return;
  }

  function getTrack() {
    return mobileCardsMq.matches && cardsTrack ? cardsTrack : viewport;
  }

  function getSnapItems() {
    return getTrack().querySelectorAll('[data-mw-workshop-snap]');
  }

  if (!getSnapItems().length) {
    return;
  }

  function getActiveIndex() {
    const track = getTrack();
    const snapItems = getSnapItems();
    const trackRect = track.getBoundingClientRect();
    const styles = getComputedStyle(track);
    const scrollPadLeft = parseFloat(styles.scrollPaddingLeft) || 0;
    const snapLine = trackRect.left + scrollPadLeft;

    let activeIndex = 0;
    let minDistance = Infinity;

    snapItems.forEach((item, index) => {
      const distance = Math.abs(item.getBoundingClientRect().left - snapLine);
      if (distance < minDistance) {
        minDistance = distance;
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  function updateNavButtons() {
    const snapItems = getSnapItems();
    const activeIndex = getActiveIndex();

    if (prevBtn) {
      prevBtn.hidden = activeIndex === 0;
    }

    if (nextBtn) {
      nextBtn.hidden = activeIndex >= snapItems.length - 1;
    }

    updatePagination(activeIndex);
  }

  function updatePagination(activeIndex) {
    if (!paginationDots?.length || !mobileCardsMq.matches) {
      return;
    }

    paginationDots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function carouselScrollBehavior() {
    const settings = getMotionSettings();
    if (!settings.enabled) return 'auto';
    return settings.workshopCarouselSmooth === false ? 'auto' : 'smooth';
  }

  function scrollToIndex(index) {
    const track = getTrack();
    const snapItems = getSnapItems();
    const targetIndex = Math.max(0, Math.min(index, snapItems.length - 1));
    const item = snapItems[targetIndex];
    const scrollPadLeft = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
    const targetLeft =
      track.scrollLeft +
      item.getBoundingClientRect().left -
      track.getBoundingClientRect().left -
      scrollPadLeft;
    const maxScroll = track.scrollWidth - track.clientWidth;

    track.scrollTo({
      left: Math.max(0, Math.min(targetLeft, maxScroll)),
      behavior: carouselScrollBehavior(),
    });
  }

  function scrollByStep(delta) {
    scrollToIndex(getActiveIndex() + delta);
  }

  prevBtn?.addEventListener('click', () => scrollByStep(-1));
  nextBtn?.addEventListener('click', () => scrollByStep(1));
  scrollHint?.addEventListener('click', () => scrollByStep(1));

  paginationDots?.forEach((dot, index) => {
    dot.addEventListener('click', () => scrollToIndex(index));
  });

  function bindTrackScroll() {
    viewport.removeEventListener('scroll', onTrackScroll);
    cardsTrack?.removeEventListener('scroll', onTrackScroll);
    getTrack().addEventListener('scroll', onTrackScroll, { passive: true });
  }

  function onTrackScroll() {
    window.requestAnimationFrame(updateNavButtons);
  }

  function onLayoutChange() {
    bindTrackScroll();
    updateNavButtons();
  }

  bindTrackScroll();
  window.addEventListener('resize', onLayoutChange, { passive: true });
  mobileCardsMq.addEventListener('change', onLayoutChange);
  updateNavButtons();
})();

/* Global cart FAB — badge sync + safer section HTML parsing */
(function initMwCartFab() {
  function parseCartIconSectionHtml(html) {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section =
      doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
    return section ? section.innerHTML : html;
  }

  function setCartFabHasItems(fab, hasItems) {
    fab.classList.toggle('mw-cart-fab--has-items', hasItems);
  }

  function renderCartFabCount(fab, count) {
    let bubble = fab.querySelector('.mw-cart-count-bubble, .cart-count-bubble');

    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble mw-cart-count-bubble';
        fab.appendChild(bubble);
      }

      if (count < 100) {
        bubble.innerHTML = `<span class="mw-cart-count-bubble__count" aria-hidden="true">${count}</span>`;
      } else {
        bubble.innerHTML = '';
      }
    } else if (bubble) {
      bubble.remove();
    }

    setCartFabHasItems(fab, count > 0);
    fab.setAttribute(
      'aria-label',
      count > 0 ? `Cart (${count})` : fab.getAttribute('data-mw-cart-label-empty') || 'Cart'
    );
  }

  function getCartCountFromResponse(cartData) {
    if (typeof cartData.item_count === 'number') return cartData.item_count;

    const countEl = document
      .getElementById('cart-icon-bubble')
      ?.querySelector('.mw-cart-count-bubble__count');
    const existing = countEl ? parseInt(countEl.textContent, 10) : 0;
    const added = Array.isArray(cartData.items)
      ? cartData.items.reduce((sum, item) => sum + (item.quantity || 0), 0)
      : 0;

    if (added > 0) return (Number.isFinite(existing) ? existing : 0) + added;
    return null;
  }

  function syncCartFabFromCartData(cartData) {
    const fab = document.getElementById('cart-icon-bubble');
    if (!fab || !cartData) return;

    const sectionHtml = cartData.sections?.['cart-icon-bubble'];
    if (sectionHtml) {
      fab.innerHTML = parseCartIconSectionHtml(sectionHtml);
      const countSpan = fab.querySelector('.mw-cart-count-bubble__count');
      let count = countSpan ? parseInt(countSpan.textContent, 10) : NaN;

      if (!Number.isFinite(count) || count <= 0) {
        count = getCartCountFromResponse(cartData);
        if (Number.isFinite(count) && count > 0) renderCartFabCount(fab, count);
      }

      setCartFabHasItems(
        fab,
        fab.querySelector('.mw-cart-count-bubble__count') !== null ||
          fab.querySelector('.mw-cart-count-bubble, .cart-count-bubble') !== null
      );
      return;
    }

    const count = getCartCountFromResponse(cartData);
    if (Number.isFinite(count) && count > 0) renderCartFabCount(fab, count);
  }

  function patchCartSectionParser(proto) {
    if (!proto?.getSectionInnerHTML) return;

    proto.getSectionInnerHTML = function (html, selector = '.shopify-section') {
      if (!html) return '';
      if (selector === '.shopify-section' || !selector) {
        if (this.tagName === 'CART-NOTIFICATION') {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.querySelector('.shopify-section');
          return section ? section.innerHTML : '';
        }
        return parseCartIconSectionHtml(html);
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section =
        doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
      if (!section) return '';
      const target = section.querySelector(selector) || section;
      return target.innerHTML;
    };

    const originalRender = proto.renderContents;
    if (originalRender) {
      proto.renderContents = function (parsedState) {
        originalRender.call(this, parsedState);
        syncCartFabFromCartData(parsedState);
      };
    }
  }

  function resetCartPageInteractivity() {
    if (!document.body.classList.contains('mw-template') || !window.location.pathname.includes('/cart')) {
      return;
    }

    document.getElementById('main-cart-items')?.classList.remove('cart__items--disabled');
    document.querySelectorAll('.cart-item .loading__spinner').forEach((spinner) => {
      spinner.classList.add('hidden');
    });
  }

  function init() {
    resetCartPageInteractivity();

    const fab = document.getElementById('cart-icon-bubble');
    if (fab) {
      if (!fab.dataset.mwCartLabelEmpty) {
        fab.dataset.mwCartLabelEmpty = fab.getAttribute('aria-label') || 'Cart';
      }
      setCartFabHasItems(fab, fab.querySelector('.mw-cart-count-bubble, .cart-count-bubble') !== null);
    }

    patchCartSectionParser(customElements.get('cart-notification')?.prototype);
    patchCartSectionParser(customElements.get('cart-drawer')?.prototype);
    patchCartSectionParser(customElements.get('cart-items')?.prototype);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.cartData) syncCartFabFromCartData(event.cartData);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector?.('cart-items')) resetCartPageInteractivity();
  });
})();

/* Cart: Continue shopping returns to the page visited before /cart */
(function initMwContinueShopping() {
  const STORAGE_KEY = 'mw_continue_shopping_return';

  function isCartPath(pathname) {
    return pathname === '/cart' || pathname.startsWith('/cart/');
  }

  function isCheckoutPath(pathname) {
    return pathname.includes('/checkouts/') || pathname === '/checkout';
  }

  function isUsableReturnPath(pathname) {
    return pathname && !isCartPath(pathname) && !isCheckoutPath(pathname);
  }

  function saveReturnUrl() {
    if (!isUsableReturnPath(window.location.pathname)) return;
    sessionStorage.setItem(STORAGE_KEY, window.location.pathname + window.location.search);
  }

  function resolveReturnUrl() {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        const { pathname, search } = new URL(stored, window.location.origin);
        if (isUsableReturnPath(pathname)) {
          return pathname + search;
        }
      } catch {
        /* ignore invalid stored URL */
      }
    }

    if (document.referrer) {
      try {
        const ref = new URL(document.referrer);
        if (ref.origin === window.location.origin && isUsableReturnPath(ref.pathname)) {
          return ref.pathname + ref.search;
        }
      } catch {
        /* ignore invalid referrer */
      }
    }

    return null;
  }

  function applyCartContinueLinks() {
    if (!isCartPath(window.location.pathname)) return;

    const returnUrl = resolveReturnUrl();
    document.querySelectorAll('.mw-cart-continue-shopping').forEach((link) => {
      const fallback = link.dataset.mwFallbackUrl || link.getAttribute('href') || '/';
      link.href = returnUrl || fallback;
    });
  }

  function init() {
    saveReturnUrl();
    applyCartContinueLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector?.('.mw-cart-continue-shopping')) {
      applyCartContinueLinks();
    }
  });
})();

/* Workshop: multi-select sessions — add multiple variants to cart */
(function initMwWorkshopSessionPicker() {
  function getProductInfo(picker) {
    return picker.closest('product-info');
  }

  function updateSubmitLabel(productInfo, count) {
    const submitButton = productInfo?.querySelector('.product-form__submit[type="submit"]');
    const submitText =
      submitButton?.querySelector('.mw-workshop-purchase__submit-text') ||
      submitButton?.querySelector('span:not(.svg-wrapper):not(.mw-workshop-purchase__submit-inner)');
    if (!submitText) return;

    if (count === 0) {
      submitText.textContent = 'Select session(s)';
      submitButton?.setAttribute('aria-disabled', 'true');
    } else if (count === 1) {
      submitText.textContent = window.variantStrings?.addToCart || 'Add to cart';
      submitButton?.removeAttribute('aria-disabled');
    } else {
      submitText.textContent = `Add ${count} sessions to cart`;
      submitButton?.removeAttribute('aria-disabled');
    }
  }

  function syncFirstSelection(picker, sessionButton) {
    const variantSelects = picker.closest('variant-selects');
    const optionValueId = sessionButton.dataset.optionValueId;
    if (!variantSelects || !optionValueId) return;

    variantSelects.querySelectorAll('.mw-variant-sync input[type="radio"]').forEach((input) => {
      input.checked = input.dataset.optionValueId === optionValueId;
    });
  }

  function initPicker(picker) {
    const productInfo = getProductInfo(picker);
    const sessions = picker.querySelectorAll('[data-mw-workshop-session]');

    sessions.forEach((session) => {
      if (session.dataset.mwWorkshopBound === 'true') return;
      session.dataset.mwWorkshopBound = 'true';

      session.addEventListener('click', () => {
        if (session.disabled) return;

        const selected = !session.classList.contains('is-selected');
        session.classList.toggle('is-selected', selected);
        session.setAttribute('aria-pressed', selected ? 'true' : 'false');

        const selectedSessions = picker.querySelectorAll(
          '[data-mw-workshop-session].is-selected:not([disabled])'
        );
        updateSubmitLabel(productInfo, selectedSessions.length);

        if (selectedSessions.length === 1) {
          syncFirstSelection(picker, selectedSessions[0]);
          const variantId = selectedSessions[0].dataset.variantId;
          if (variantId && productInfo) {
            productInfo.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach((input) => {
              input.value = variantId;
              input.disabled = false;
            });
          }
        }
      });
    });

    updateSubmitLabel(productInfo, 0);
  }

  function initAllPickers() {
    document.querySelectorAll('[data-mw-workshop-picker]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPickers);
  } else {
    initAllPickers();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-mw-workshop-picker]').forEach(initPicker);
  });

  document.addEventListener('product-info:loaded', initAllPickers);

  function getFormQuantity(productForm) {
    const productInfo = productForm.closest('product-info');
    const input =
      productForm.querySelector('input[name="quantity"]') ||
      productInfo?.querySelector('input[name="quantity"]');
    if (!input) return 1;

    let quantity = parseInt(input.value, 10);
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

    const min = parseInt(input.min || input.dataset.min, 10);
    const max = parseInt(input.max || input.dataset.max, 10);
    if (Number.isFinite(min) && quantity < min) quantity = min;
    if (Number.isFinite(max) && quantity > max) quantity = max;

    return quantity;
  }

  window.MwWorkshopCart = {
    getSelectedItems(productForm) {
      const picker = productForm.closest('product-info')?.querySelector('[data-mw-workshop-picker]');
      if (!picker) return null;

      const selected = picker.querySelectorAll('[data-mw-workshop-session].is-selected:not([disabled])');
      if (!selected.length) return [];

      const quantity = getFormQuantity(productForm);
      const lineStamp = Date.now();

      return Array.from(selected).map((session, index) => {
        const sessionLabel = (session.dataset.value || session.textContent || '').trim();
        const item = {
          id: session.dataset.variantId,
          quantity,
          properties: {
            Session: sessionLabel,
          },
        };

        /* Split separate sessions into distinct lines; one session + qty uses a single line */
        if (selected.length > 1) {
          item.properties._mw_line = `${lineStamp}-${index}`;
        }

        return item;
      });
    },
  };
})();
